export const routes = {
    Home:"/",
    Service:"/services",
    Gallery:"/gallery",
    GetOrder:"/getorder",
    NotFound:"*"
}